"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return GalleryView;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _extractProps = require("~/helpers/extractProps");
const _globals = require("~/utils/globals");
const _modelUtils = require("~/utils/modelUtils");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let GalleryView = class GalleryView {
    static async get(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let view = viewId && await _NocoCache.default.get(context, `${_globals.CacheScope.GALLERY_VIEW}:${viewId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!view) {
            view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW, {
                fk_view_id: viewId
            });
            await _NocoCache.default.set(context, `${_globals.CacheScope.GALLERY_VIEW}:${viewId}`, view);
        }
        return view && new GalleryView(view);
    }
    static async insert(context, view, ncMeta = _Noco.default.ncMeta) {
        var _columns_find, _parseMetaProp;
        const columns = await _View.default.get(context, view.fk_view_id, ncMeta).then((v)=>v == null ? void 0 : v.getModel(context, ncMeta)).then((m)=>m.getColumns(context, ncMeta));
        const insertObj = (0, _extractProps.extractProps)(view, [
            'base_id',
            'source_id',
            'fk_view_id',
            'next_enabled',
            'prev_enabled',
            'cover_image_idx',
            'cover_image',
            'restrict_types',
            'restrict_size',
            'restrict_number',
            'meta'
        ]);
        insertObj.fk_cover_image_col_id = (view == null ? void 0 : view.fk_cover_image_col_id) !== undefined ? view == null ? void 0 : view.fk_cover_image_col_id : columns == null ? void 0 : (_columns_find = columns.find((c)=>c.uidt === _nocodbsdk.UITypes.Attachment)) == null ? void 0 : _columns_find.id;
        insertObj.meta = {
            fk_cover_image_object_fit: ((_parseMetaProp = (0, _modelUtils.parseMetaProp)(insertObj)) == null ? void 0 : _parseMetaProp.fk_cover_image_object_fit) || 'fit'
        };
        insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        const viewRef = await _View.default.get(context, insertObj.fk_view_id, ncMeta);
        if (!insertObj.source_id) {
            insertObj.source_id = viewRef.source_id;
        }
        await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW, insertObj, true);
        return this.get(context, view.fk_view_id, ncMeta);
    }
    static async update(context, galleryId, body, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'fk_cover_image_col_id',
            'meta'
        ]);
        // update meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW, (0, _modelUtils.prepareForDb)(updateObj), {
            fk_view_id: galleryId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.GALLERY_VIEW}:${galleryId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        const view = await _View.default.get(context, galleryId, ncMeta);
        // on update, delete any optimised single query cache
        await _View.default.clearSingleQueryCache(context, view.fk_model_id, [
            {
                id: galleryId
            }
        ], ncMeta);
        return res;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
